import { apiGet, type ApiResponse } from "./genesisApi/httpsMethods";

export interface DealHistoryEntry {
  field_name: string;
  old_value: string | null;
  new_value: string | null;
  date_changed: string;
  changed_by: string | null;
}

export interface DealHistoryResponse {
  deal_id: number;
  history: DealHistoryEntry[];
}

export function buildDealHistoryUrl(dealId: number): string {
  return `deal/${dealId}/history`;
}

export async function getDealHistory(
  dealId: number,
): Promise<ApiResponse<DealHistoryResponse>> {
  return apiGet<DealHistoryResponse>(buildDealHistoryUrl(dealId));
}
